import FinanceXSubscriptionDetail from './FinanceXSubscriptionDetail.component';

export default FinanceXSubscriptionDetail;
